export default __webpack_public_path__ + "assets/CircleWavyWarning.a993f198.svg";